/**
 * Feature flag utilities
 * 
 * Features are stored in the user_features table and loaded into the user object
 * on login. Use hasFeature() to check if a user has access to a feature.
 */

/**
 * Check if a user has a specific feature enabled
 * @param {Object} user - User object from AuthContext
 * @param {string} feature - Feature name (e.g. 'a2a', 'seller_asins')
 * @returns {boolean}
 */
export function hasFeature(user, feature) {
  if (!user?.features) return false;
  return user.features.includes(feature);
}

/**
 * Feature constants
 */
export const FEATURES = {
  A2A: 'a2a',
  USPS_PICKUPS: 'usps_pickups',
  ORDER_TRACKING: 'order_tracking',
  SELLER_ASINS: 'seller_asins',
  AURA: 'aura',
  PL: 'pl',
  IOS_PREMIUM: 'ios-premium',
  PAYOUT_CALCULATOR: 'payout_calculator',
  TAX_RECOVERY: 'tax_recovery',
  A2E_SOURCING: 'a2e_sourcing',
};
